import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { FaseService } from '../../fase/fase.service';
import { ArquivoService } from '../../shared/services/arquivo.service';

@Component({
  templateUrl: './termo-aceite.component.html',
  styleUrls: ['termo-aceite.component.css']
})
export class TermoAceiteComponent extends WebPage implements OnInit {

  validado = false;

  idFase;
  fase;

  constructor(
    private faseService: FaseService, private arquivoService: ArquivoService,
    private router: Router, private route: ActivatedRoute,
    messageService: MessageService
  ) {
    super(messageService);

    this.route.paramMap.subscribe(params =>
      this.idFase = params.get('idFase')
    );
  }

  ngOnInit() {
    this.isLoading = true;
    this.isHeader = false;
    console.log(this.isHeader);
    this.faseService.getFull(this.idFase)
      .finally(() => this.isLoading = false)
      .subscribe(
        fase => this.fase = fase,
        error => this.gerenciaErro(error)
      );
  }

  baixarEdital() {
    this.validado = true;
    this.arquivoService.downloadArquivo(this.fase.arquivosMeio[0].idArquivo, 'Termo_aceite');
  }

  submit() {
    this.router.navigate(['/valida-dados/' + this.idFase]);
  }

  OnDestroy(){
    this.isHeader = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/termo-aceite/termo-aceite.component.ts